import { useQuery } from '@tanstack/react-query';

export type PwaConfig = {
  name: string;
  short_name: string;
  description: string;
  background_color: string;
  theme_color: string;
  org_id?: string;
  logo?: string;
  logo_public_id?: string;
  favicon?: string;
  icons: {
    src: string;
    sizes: string;
    type: string;
  }[];
};

async function fetchPwaConfig(): Promise<PwaConfig | null> {
  const response = await fetch('/api/manifest');
  if (!response.ok) {
    throw new Error('Failed to fetch PWA config');
  }
  const manifest = await response.json();
  // Extract PWA config from manifest
  // The manifest API returns the full manifest with custom properties merged in
  return {
    name: manifest.name,
    short_name: manifest.short_name,
    description: manifest.description,
    background_color: manifest.background_color,
    theme_color: manifest.theme_color,
    org_id: manifest.org_id,
    logo: manifest.logo,
    logo_public_id: manifest.logo_public_id,
    favicon: manifest.favicon,
    icons: manifest.icons,
  };
}

export function usePwaConfig() {
  const { data: config, isLoading } = useQuery(['pwaConfig'], fetchPwaConfig, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return { config: config || null, isLoading };
}
